import React, { useState } from "react";
import "./qualification.css";

const Qualification = () => {
  const [toggleState, setToggleState] = useState(2);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  return (
    <section className="qualification section">
      <h2 className="section__title">Qualification</h2>
      <span className="section__subtitle">My personal journey</span>

      <div className="qualification__container container">
        <div className="qualification__tabs">
          <div
            className={
              toggleState === 1
                ? "qualification__button qualification__active button--flex"
                : "qualification__button button--flex"
            }
            onClick={() => toggleTab(1)}
          >
            <i className="uil uil-graduation-cap qualification__icon"></i>{" "}
            Education
          </div>

          <div
            className={
              toggleState === 2
                ? "qualification__button qualification__active button--flex"
                : "qualification__button button--flex"
            }
            onClick={() => toggleTab(2)}
          >
            <i className="uil uil-briefcase-alt qualification__icon"></i>{" "}
            Experience
          </div>
        </div>

        <div className="qualification__sections">
          <div
            className={
              toggleState === 1
                ? "qualification__content qualification__content-active"
                : "qualification__content"
            }
          >
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">
                  Udemy Course
                  <br />
                  React the Complete Guide: Dive in and learn React.js from
                  scratch! Learn Reactjs, Hooks, Redux, React Routing,
                  Animations, Next.js and way more!
                  <br />
                  By Maximilian Schwarzmüller
                </h3>
                <span className="qualification__subtitle">
                  50h of content & activities
                </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> November '22 -
                  Present
                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>

            <div className="qualification__data">
              <div></div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
              <div>
                <h3 className="qualification__title">
                  Ironhack FULLSTACK WEB DEVELOPMENT Bootcamp (M.E.R.N)
                </h3>
                <span className="qualification__subtitle">
                  Spain - Institute
                </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> September '22 -
                  November '22
                </div>
              </div>
            </div>

            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">
                  Higher National Certificate in Transportation and Logistics
                </h3>
                <span className="qualification__subtitle">
                  Spain - Institut de Vic
                </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> 2020 - 2021
                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>

            <div className="qualification__data">
              <div></div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>

              <div>
                <h3 className="qualification__title">
                  Higher National Certificate in International Trade
                </h3>
                <span className="qualification__subtitle">
                  Spain - Institut de Vic
                </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> 2018 - 2020
                </div>
              </div>
            </div>
          </div>

          <div
            className={
              toggleState === 2
                ? "qualification__content qualification__content-active"
                : "qualification__content"
            }
          >
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">
                  Frontend Developer
                  <br /> <br />
                  Working on legacy repos to TypeScript & new Design System at
                  Typeform. Leveraged AI tools to accelerate delivery, resolved
                  10+ complex UI issues with pixel-perfect accuracy, and
                  authored test suites focused on a11y and performance.
                  Currently developing high-conversion landing pages with
                  Next.js, Sanity CMS, and Tailwind CSS at Uriach.
                </h3>
                <span className="qualification__subtitle">
                  TheLeftBit (Contractor at Typeform & others)
                </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> February '26 -
                  Present
                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>
            <div className="qualification__data">
              <div></div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
              <div>
                <h3 className="qualification__title">
                  React Frontend Developer
                  <br /> <br />
                  As a frontend developer, I specialize in React and Tailwind
                  CSS, and I use a range of other frontend technologies to
                  create dynamic and engaging user interfaces. I work remotely,
                  utilizing Jira for project management and Bitbucket for code
                  management. I collaborate closely with UI/UX designers to
                  deliver visually appealing web pages and work alongside QA
                  testers to ensure high-quality performance. My commitment to
                  staying up-to-date with the latest frontend development trends
                  allows me to provide cutting-edge solutions for the cool
                  brands I work with.
                </h3>
                <span className="qualification__subtitle">
                  The Crowd Digital
                </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> February '23 -
                  Present
                </div>
              </div>
            </div>
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">
                  Fullstack developer (M.E.R.N)
                  <br />
                  <br />
                  Throughout the program, I worked on several projects alongside
                  my fellow students, which allowed me to not only develop my
                  technical skills but also to learn how to work effectively in
                  a team. The collaborative nature of the program was one of the
                  biggest benefits for me, as I was able to learn from my peers
                  and share ideas and approaches to problem-solving.
                </h3>
                <span className="qualification__subtitle">
                  9 weeks intensive bootcamp, +9h everyday
                </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> September '22 -
                  November '22
                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>

            <div className="qualification__data">
              <div></div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
              <div>
                <h3 className="qualification__title">
                  B2B National Sales Manager
                </h3>
                <span className="qualification__subtitle">
                  Nunest Food S.L.
                </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> February '22 - August
                  '22
                </div>
              </div>
            </div>

            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">
                  Costs Department Administrative Assistant
                </h3>
                <span className="qualification__subtitle">
                  Casa Tarradellas
                </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> 2020 - 2022
                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>

            <div className="qualification__data">
              <div></div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>

              <div>
                <h3 className="qualification__title">Export Assistant</h3>
                <span className="qualification__subtitle">
                  The Netherlands - The Oriental Shop B.V.
                </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> 2019 - 2020
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Qualification;
